export default "__VITE_ASSET__Dnsx_l06__"